module.exports = __webpack_public_path__ + "media/images/slides/temma_bridge-cc6bab2a4062907204ee3d0460594e12.jpg";